
import UserForm from "../UserForm";
type addUserModalTypes = {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<false | true>>;
};
export default function AddUser({ open, setOpen }: addUserModalTypes) {
  return <UserForm open={open} setOpen={setOpen} />;
}
